// Stack Sans Text (the --font-heading typeface) from @fontsource, like Inter/Geist. The
// @font-face is injected into the document, not the shadow root, because shadow roots can't
// load fonts. One face with a weight range covers the whole variable (wght) axis.
import stackSansVariable from '@fontsource-variable/stack-sans-text/files/stack-sans-text-latin-wght-normal.woff2';

const STYLE_ID = 'malachite-stack-sans-font-face';

let injected = false;

export const ensureStackSansFontFace = (): void => {
    if (injected || typeof document === 'undefined' || !document.head) {
        return;
    }
    if (document.getElementById(STYLE_ID)) {
        injected = true;
        return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `@font-face{font-family:'Stack Sans Text';font-style:normal;font-weight:100 900;font-display:swap;src:url('${stackSansVariable}') format('woff2');}`;
    document.head.appendChild(style);
    injected = true;
};
